import { render, staticRenderFns } from "./Plataformas.vue?vue&type=template&id=7f8bb0f2"
import script from "./Plataformas.vue?vue&type=script&lang=js"
export * from "./Plataformas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports